import { render } from "./Signature.vue?vue&type=template&id=06eaec04"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__